import { useTranslation } from 'react-i18next';
import { Bell, ArrowLeft } from 'lucide-react';

interface HeaderProps {
  title?: string;
  showBack?: boolean;
  showNotification?: boolean;
  onBack?: () => void;
}

export function Header({ title, showBack, showNotification, onBack }: HeaderProps) {
  const { t } = useTranslation();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <header className="bg-surface border-b border-border-light sticky top-0 z-40">
      <div className="flex items-center justify-between px-5 py-3.5 max-w-[480px] mx-auto">
        {showBack ? (
          <button
            onClick={handleBack}
            className="p-2 -ml-2 hover:bg-background rounded-xl transition-colors cursor-pointer"
          >
            <ArrowLeft className="w-5 h-5 text-text-primary" />
          </button>
        ) : (
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center shadow-sm">
              <span className="text-white text-sm font-black">!</span>
            </div>
            <h1 className="text-[17px] font-bold text-text-primary tracking-tight">
              {title || t('app.name')}
            </h1>
          </div>
        )}

        {!showBack && title && (
          <h1 className="text-[17px] font-bold text-text-primary flex-1 text-center tracking-tight">
            {title}
          </h1>
        )}

        {showNotification && (
          <button className="p-2 hover:bg-background rounded-xl transition-colors cursor-pointer relative">
            <Bell className="w-5 h-5 text-text-secondary" />
          </button>
        )}

        {!showNotification && !showBack && <div className="w-10" />}
      </div>
    </header>
  );
}
